type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
};

export function ArrowRightIcon({ width = 16, height = 16, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            className={className}
            style={style}
        >
            <path
                d="M8.69635 3.87523L11.9878 7.16667H2.16634C2.13757 7.16667 2.10915 7.16813 2.08113 7.171C1.66092 7.21367 1.33301 7.56853 1.33301 8C1.33301 8.46027 1.7061 8.83333 2.16634 8.83333H11.9878L8.69635 12.1248C8.37095 12.4503 8.37095 12.9779 8.69635 13.3033C9.02182 13.6287 9.54942 13.6287 9.87489 13.3033L14.589 8.58927C14.9144 8.26387 14.9144 7.7362 14.589 7.41073L9.87489 2.69671C9.86982 2.69163 9.86469 2.68663 9.85949 2.6817C9.82322 2.64721 9.78462 2.61663 9.74415 2.58993C9.51309 2.43738 9.22282 2.41196 8.97202 2.51365C8.87175 2.55433 8.77775 2.61535 8.69635 2.69671C8.69129 2.7018 8.68629 2.70693 8.68135 2.71211C8.37102 3.03859 8.37602 3.55487 8.69635 3.87523Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default ArrowRightIcon;
